import "./animated-counter.scss";

import { animate,motion, useMotionValue } from "framer-motion";
import { useEffect, useState } from "react";

 
export interface AnimatedCounterProps {
  label: string;
  from: number;
  to: number;
  duration?: number;
  delay?: number;
}

export function AnimatedCounter({
  label,
  from,
  to,
  duration,
  delay,
}: AnimatedCounterProps) {
  // DECLARATIONS
  const [displayValue, setDisplayValue] = useState(from);
  const count = useMotionValue(from);

  // API DEFINITIONS

  // LOCAL FUNCTIONS
  useEffect(() => {
    const controls = animate(count, to, {
      duration,
      delay,
      onUpdate: (latest) => {
        const numeric = Number(latest);
        if (!isNaN(numeric)) {
          setDisplayValue(Math.floor(numeric));
        }
      },
    });

    return controls.stop;
  }, [from, to, duration, delay, count]);

  // LOCAL RENDERS

  return (
    <div
      id="AnimatedCounter"
      className="animated-counter flex flex-col items-center justify-center"
    >
      <motion.div
        className="text-4xl font-bold text-blue-600"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <span className="text-5xl">{displayValue}</span>
      </motion.div>
      <span>{label}</span>
    </div>
  );
}

export default AnimatedCounter;
